/**
 * @desc: -  日工资 团队管理 注册弹出框
 * @author: danny
 */

import {DateGroup,RangeGroup,SearchGroup,Pagintaion,Bread} from "../ReportComponent.jsx";
import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as baseAction from '../../../../actions/baseAction'
import * as userAction from '../../../../actions/userAction'
import * as commonAction from "../../../../actions/commonAction";
import * as reportAction from "../../../../actions/reportAction";

import ReportBase from '../ReportBase.jsx'
import Popup from "../../../../components/modal/popup.jsx";
class LotteryBetRecord extends ReportBase{
	constructor(props){
		super(props)
	}
	refer(){

	}
	
	breadRefer(){
	}
	
	render(){
		const __base = this.props.__BASE.toJS();
		const __report = this.props.__REPORT.toJS();
		
		if(!__report.current_view ) return <div></div>
		const {searchValue,orderBy,sort} = this.state;
		
		
		return <div className="popup-small-container">
			<div className="link-container">
				<div className="pop-title-warp">
					<h6 className="title">推广链接</h6>
				</div>
				
				<div className="fb-setting">
					<span className="fbset">返点：</span>
					<RangeGroup title=""
					            rangeMenuInfo={[{title:"5.6",optionValue:5.6},{title:"5.7",optionValue:5.7}]}
					            rangeMenuClick={this.rangeMenuClick}/>
					<span className="code">%</span>
					<span className="blue-botton">保存更新</span>
				</div>
				
				<div className="title-warp">
					<i className="ball"></i>
					<span >以下为您的推广链接：</span>
					<a>返回详情>></a>
					
				</div>
				
				
				<div className="copy-warp">
					<span>【彩票游戏】链接：</span>
					<RangeGroup title=""
					            rangeMenuInfo={[{title:"5.6",optionValue:5.6},{title:"5.7",optionValue:5.7}]}
					            rangeMenuClick={this.rangeMenuClick}/>
					<span className="code">%</span>
					<span className="blue-botton">复制</span>
				</div>
			</div>
		
		</div>
	}
}

reactMixin(LotteryBetRecord.prototype, ImmutableMixin);

function mapStateToProps(state) {
	return {
		__BASE: state.base,
		__USER: state.user,
		__REPORT:state.report
	}
}

function mapDispatchToProps(dispatch) {
	return {
		$$USER: bindActionCreators(userAction, dispatch),
		$$COMMON: bindActionCreators(commonAction, dispatch),
		$$BASE: bindActionCreators(baseAction, dispatch),
		$$REPORT:bindActionCreators(reportAction, dispatch),
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LotteryBetRecord)
